import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';
import KabobMenuItem from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu/KabobMenuItem';
import React from 'react';
import PropTypes from 'prop-types';

const AdvancedEditKabobItem = ({ resource }) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { loadModalCollectionByLink } = useModalContext();

  const handleClick = () => {
    loadModalCollectionByLink(resource.relationship(fr.relationships.facetPlanOutcomeWizardNavigation.name).link('related').url());
    logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'advanced editing outcome');
  };

  return (
    <KabobMenuItem
      label={'Advanced Editing'}
      onClick={() => {
        handleClick();
      }}
    />
  );
};

AdvancedEditKabobItem.defaultProps = {};

AdvancedEditKabobItem.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default AdvancedEditKabobItem;
